import React from 'react';

import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

// Components
import { Mui, TextField } from 'components';
import { InputMask } from 'components/common';
import { Stack } from 'components/layouts';

function Basic({ onSubmit }) {
  // Contants
  const formMessages = {
    partnerName: {
      label: 'Razão social ou nome fantasia do parceiro',
      required: 'É necessário preencher o nome do parceiro',
    },
    contactName: { label: 'Nome do contato', required: 'É necessário preencher o nome do contato' },
    phoneNumber: {
      label: 'Telefone do contato',
      required: 'É necessário preencher o telefone do contato',
    },
    email: { label: 'E-mail do contato', email: 'E-mail inválido' },
  };

  // Formik
  const initialValues = {
    partnerName: '',
    contactName: '',
    phoneNumber: '',
    email: '',
  };

  const yup = Yup.object().shape({
    partnerName: Yup.string().required(formMessages.partnerName.required),
    contactName: Yup.string().required(formMessages.contactName.required),
    phoneNumber: Yup.string().required(formMessages.phoneNumber.required),
    email: Yup.string().nullable().email(formMessages.email.email).notRequired(),
  });

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema: yup,
    enableReinitialize: true,
  });

  const disabled = formik.isSubmitting;

  return (
    <Stack>
      <TextField
        required
        name="partnerName"
        formik={formik}
        messages={formMessages}
        disabled={disabled}
        margin="none"
      />
      <TextField
        required
        name="contactName"
        formik={formik}
        messages={formMessages}
        disabled={disabled}
        margin="none"
      />
      <TextField
        required
        name="phoneNumber"
        formik={formik}
        messages={formMessages}
        disabled={disabled}
        margin="none"
        InputProps={{ inputComponent: InputMask.MaskedPhoneNumber }}
      />
      <TextField
        name="email"
        formik={formik}
        messages={formMessages}
        disabled={disabled}
        margin="none"
      />

      <Mui.Box display="flex" justifyContent="flex-end">
        <Mui.Button
          size="large"
          loading={formik.isSubmitting}
          disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
          onClick={formik.submitForm}>
          Salvar
        </Mui.Button>
      </Mui.Box>
    </Stack>
  );
}

Basic.propTypes = {
  onSubmit: PropTypes.func,
};

export default Basic;
